
import { Link, View } from '@smarterservices/smarter-ui';
import config from '../../../config';
import QRCode from '@ui/shared/components/Common/QRCode';
import Loader from '../../Common/Loader';

/**
 * QRCodeConnection Component
 * 
 * Displays a QR code for connecting a second camera device to the proctoring session.
 * The component shows either a QR code with connection URL when the device link code
 * is available, or a loading state while the code is being generated.
 * 
 * @param {Object} props - Component props
 * @param {Object} props.stepData - Step configuration data containing display texts
 * @param {string} props.stepData.cannotScanQRCodeText - Text for the manual scan fallback link
 * @param {string} props.stepData.generatingLinkCodeText - Text shown while generating the link code
 * @param {string} props.deviceLinkCode - Unique code for device connection (null/undefined while loading)
 * @param {Function} props.setRightPaneContent - Function to change the right pane content
 * @returns {React.ReactElement} QR code display or loading state
 */
const QRCodeConnection = ({ stepData, deviceLinkCode, setRightPaneContent }) => {

  return (
    <>
      {deviceLinkCode ? (
        <>
          {/* QR Code display with connection URL */}
          <View as="div">
            <QRCode
              value={`${config.proctoring.ui.secondCamera.deviceBaseUrl}/session/second-camera?code=${deviceLinkCode}`}
              options={{
                width: 300,
                margin: 1,
              }}
            />
          </View>

          {/* Fallback link for manual connection */}
          <View as="div" margin="small 0 0 0">
            <Link
              as="button"
              onClick={() => {
                setRightPaneContent('manualScan');
              }}
              isWithinText={false}
              margin="0"
            >
              {stepData?.cannotScanQRCodeText}
            </Link>
          </View>
        </>
      ) : (
        /* Loading state while device link code is being generated */
        <Loader text={stepData?.generatingLinkCodeText} />
      )}
    </>
  );
};

export default QRCodeConnection;
